const RecentUploadsChartColumnIds = {
  newUsers: 'New Users',
  updateUsers: 'Update Users',
  errorUsers: 'Total Errors',
} as const;

export default RecentUploadsChartColumnIds;
